/**
 * workspaceTableAdapter — Converts WorkspaceTable[] to TableEntry[]
 * so that workspace tables can be rendered in the shared TableBrowser component.
 *
 * Key difference from connector tables: workspace tables already have columns
 * loaded in-memory (from useWorkspaceTables), so no lazy-loading is needed.
 */
import type { TableEntry, TableColumnInfo } from './TableBrowser';
import type { WorkspaceTable } from '../../services/workspaceApi';

export function workspaceTablesToEntries(tables: WorkspaceTable[]): TableEntry[] {
  return tables.map(
    (wt): TableEntry => ({
      name: wt.name,
      rowCountEstimate: wt.row_count,
      columnCount: wt.column_count,
      columns: wt.columns?.map(
        (c): TableColumnInfo => ({
          name: c.name,
          dtype: c.type, // DuckDB types (VARCHAR, BIGINT, etc.) — handled by columnTypeUtils
          nullable: true, // workspace API doesn't track nullability
        }),
      ),
    }),
  );
}
